import { observeLazySources, observeResourcesInContainer } from './modules/lazy-sources-loader.js';
import { loadMore } from './modules/load-more';
import { categoryFilter } from './modules/category-filter';

/* need for old browsers without defer */
document.addEventListener(
  `DOMContentLoaded`,
  () => {
    /* initialization of lazy loading */
    const lazySourceObserver = observeLazySources();

    const $loadMoreButton = document.querySelector(`.js-load-more-button`);
    const $categoryFilterButtons = document.querySelectorAll(`.js-category-filter`);
    const $articlesContainer = document.querySelector(`.js-articles`);
    const $categoryFilterContainer = document.querySelector(`.js-articles-category`);

    categoryFilter(
      $categoryFilterContainer,
      $categoryFilterButtons,
      (categoryId) =>
        `${window.Site.fullDomain}/ajax/posts-category/?user_id=${window.Site.entity_id}${
          categoryId ? `&category_id=${categoryId}` : ``
        }`,
      () => observeResourcesInContainer(lazySourceObserver)($categoryFilterContainer),
    );

    loadMore(
      $articlesContainer,
      $loadMoreButton,
      (nextPage, categoryId) =>
        `${window.Site.fullDomain}/ajax/posts/?page=${nextPage}&user_id=${window.Site.entity_id}${
          categoryId ? `&category_id=${categoryId}` : ``
        }`,
      ($newArticlesContainer) =>
        observeResourcesInContainer(lazySourceObserver)($newArticlesContainer),
    );
  },
  false,
);
